@import '../../shared/frame';
